module.exports = __webpack_public_path__ + "img/play-icon.05d74dfa.png";